export function isNumeric(value: any): value is number {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

export function randomByTimestamp(): number {
  return Number(`${Date.now()}${Math.round(Math.random() * 1000)}`);
}
